export default __webpack_public_path__ + "static/N0136-527ec323837089f2c429ba2771942730.png";